module.exports = __webpack_public_path__ + "media/images/lb/333-70ce0a6005b67cbaa6c797854b972d84.svg";